<div fxLayout="row" fxFill>
  <mat-table [dataSource]="dataSource" matSort #sortForDataSource="matSort" fxFill>
    <mat-header-row *matHeaderRowDef="dataSourceColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: dataSourceColumns"> </mat-row>
    <ng-container matColumnDef="index">
      <mat-header-cell *matHeaderCellDef mat-sort-header>#</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.index }}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="fullNumber">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'contacts.col_number' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.fullNumber }}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="shortNumber">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'contacts.col_short' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.shortNumber }}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="terminalType">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'contacts.col_terminal_type' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ terminalTypes[row.terminalType]?.name | translate }}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="inboundTriggering">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'contacts.col_inbound_triggering' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <mat-checkbox color="primary" disabled [checked]="row.inboundTriggering"></mat-checkbox>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="outboundTriggering">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'contacts.col_outbound_triggering' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <mat-checkbox color="primary" disabled [checked]="row.outboundTriggering"></mat-checkbox>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="category">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'contacts.col_category' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ terminalCategories[row.category].name | translate }}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="trunkProvider">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'contacts.col_trunk_provider' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.trunkProvider }}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="trunkId">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'contacts.col_trunk_id' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.trunkId }}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="enabled">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'contacts.col_enabled' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <mat-checkbox color="primary" disabled [checked]="row.enabled"></mat-checkbox>
      </mat-cell>
    </ng-container>

    <!-- Column Definition: actions -->
    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef class="right-aligned-table-column">
        <button
          *ngIf="hasAddEndUserRights()"
          mat-icon-button
          (click)="addRow()"
          color="primary"
          matTooltip="{{ 'global.add' | translate }}"
        >
          <mat-icon>playlist_add</mat-icon>
        </button>
      </mat-header-cell>
      <mat-cell *matCellDef="let row" class="right-aligned-table-column">
        <button *ngIf="hasEditEndUserRights()" mat-icon-button (click)="editRow(row)" matTooltip="{{ 'global.edit' | translate }}">
          <mat-icon>edit</mat-icon>
        </button>
        <button
          *ngIf="hasEditEndUserRights()"
          mat-icon-button
          (click)="openDeleteDialog(row)"
          matTooltip="{{ 'global.delete' | translate }}"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </mat-cell>
    </ng-container>
  </mat-table>
</div>
